import { FC, useMemo } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { ColorIcon } from '@ravago/shared/radiance/components/icon/components/ColorIcon/ColorIcon';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   colorName: string;
   producerColorCode: string | undefined;
   desiredColor: string | undefined;
}

export const ProductFlyoutColorDetails: FC<Props> = ({ colorName, producerColorCode, desiredColor }: Props) => {
   const translate = useTranslations();

   const fullColorLabel = useMemo(() => {
      if (!colorName) return undefined;

      let result = colorName;
      if (producerColorCode) result = `${result} - ${producerColorCode}`;
      if (desiredColor) result = `${result} - ${desiredColor}`;

      return result;
   }, [colorName, producerColorCode, desiredColor]);

   return (
      <Box direction="column" gap="2xs">
         <Typography component="span" variant="body-highlight">
            {translate('page-consumer.request-for-quotation.colour')}
         </Typography>
         <Box gap="2xs" items="center">
            <ColorIcon colorName={colorName?.toLowerCase()} />
            <Typography component="span" variant="body">
               {fullColorLabel}
            </Typography>
         </Box>
      </Box>
   );
};
